<template>
  <v-card class="mb-12 rich-text">
    <v-card-text>
      <h1>Before you start</h1>
      <h2>Which files and directories will you transfer to Cambridge University Library?</h2>
      <p>If you are unsure which digital materials may be of interest, please contact <a href="mailto:digitalpreservationservice@lib.cam.ac.uk">digitalpreservationservice@lib.cam.ac.uk</a> for advice.</p>
      <h2>Make a list</h2>
      <p>Your knowledge about how the digital materials were originally created, used and managed is extremely valuable. It provides essential context to ensure that they can continue to be understood and used.</p>
      <p>Prepare a list (ideally a spreadsheet) of the files and directories you plan to transfer.</p>
      <p>Transfer your list and any other background information you have about the digital files together with the files.</p>
      <br>
    </v-card-text>
  </v-card>
</template>

<script>
  import '@/styles/rich-text.css'

  export default {
    name: 'BeforeYouStart'
  }
</script>
